import { BASE_URL_LEGACY } from "./";

export const setupService = {
  getDetail,
  submitSetup,
};

function getDetail(user) {
  const requestOptions = {
    method: "GET",
    headers: { "Content-Type": "application/json" },
    credentials: "include",
  };

  return fetch(
    `${BASE_URL_LEGACY}/common/set_up/?user_id=${user}`,
    requestOptions
  )
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function submitSetup(user, values) {
  let setupBody = `user_id=${user}`;

  const sendValues = {...values};
  delete sendValues.appliances;

  const params = new URLSearchParams(sendValues);

  setupBody += '&' + params.toString();

  const requestOptions = {
    method: "POST",
    headers: {
      "Content-Type": "application/x-www-form-urlencoded",
      "X-CSRFToken": JSON.parse(localStorage.getItem("CSRF")),
    },
    credentials: "include",
    body: setupBody
  };

  return fetch(`${BASE_URL_LEGACY}/common/set_up/`, requestOptions)
    .then((response) => {
      return handleResponse(response);
    })
    .then((detail) => {
      return detail;
    });
}

function handleResponse(response) {
  if (!response.ok) {
    return Promise.reject(response.statusText);
  }

  return response.json();
}
